import { Component, EventEmitter, Output, input } from '@angular/core';
import { IServiceInfoDetail } from 'src/app/models';
import { LiteralService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-service-row',
    templateUrl: './service-row.component.html',
    styleUrl: './service-row.component.scss',
    standalone: false
})
export class ServiceRowComponent {

  readonly service = input<IServiceInfoDetail>();
  readonly index = input<number>();
  readonly serviceInfoSelected = input<any>();
  // @Input() showRoutesService: IServiceInfoDetail;
  @Output() showRoutes = new EventEmitter<any>();
  @Output() showServiceInfoData = new EventEmitter<any>();

  public images = images;
  public TooltipPosition = TooltipPosition;

  constructor(
    public utilsService: UtilsService,
    public literalService: LiteralService,
    private activatedRoute: ActivatedRoute
  ) {}

  getRouteUrl() {
    const params = this.activatedRoute.snapshot.queryParams;
    const parts: string[] = [];
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        value.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
      } else if (value !== null && value !== undefined) {
        parts.push(`${key}=${encodeURIComponent(value as string)}`);
      }
    }
    const queryParams = parts.length ? `?${parts.join('&')}` : '';
    if (!this.service()) return `/services${queryParams}`;
    return `/services/${ this.service()?.id}/routes${queryParams}`;
  }
}
